// Mirrors the server's charge-total calculation (API Task 2, already merged) so the
// FE-authenticated 3DS amount equals the server charge to the cent.
//
//   depositFeeRaw  = (program.deposit_fee / 100) * A
//   convenienceRaw = (program.convenience_fee / 100) * (A + depositFeeRaw)   // on A + RAW deposit fee
//   total          = round(A, 2) + round(depositFeeRaw, 2) + round(convenienceRaw, 2)
//
// deposit_fee / convenience_fee are whole-number percents (may be strings — coerce with
// parseFloat; missing/NaN/<=0 treated as 0), matching PaymentCreditCardStep1Form.computeFee.

const round2 = (n) => Math.round(n * 100) / 100;

const feeRate = (program, key) => {
    if (!program) return 0;
    const raw = program[key];
    const rate = typeof raw !== "undefined" && !isNaN(parseFloat(raw)) ? parseFloat(raw) / 100 : 0;
    return rate > 0 ? rate : 0;
};

export const computeDepositTotal = (base, program) => {
    const amount = parseFloat(base) || 0;

    const depositRate = feeRate(program, "deposit_fee");
    const convenienceRate = feeRate(program, "convenience_fee");

    const depositFeeRaw = depositRate * amount;
    const convenienceRaw = convenienceRate * (amount + depositFeeRaw);

    return round2(amount) + round2(depositFeeRaw) + round2(convenienceRaw);
};
